import React from "react";
import Joi from "joi-browser";
import Form from "./common/form";
import axios from "axios";
import { toast } from 'react-toastify';
import Reaptcha from "reaptcha";

const TEST_SITE_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
const SITE_KEY = "6LeZWY0bAAAAAP-9LKWPspI4OEXGb-VBn6J-wFjp"

class RegisterFoxproForm extends Form {
  state = {
    data: {
      companyName: "",
      firstname: "",
      surname: "",
      email: "",
      street: "",
      postalCode: "",
      city: "",
      countryId: "",
      phone: "",
      vendor: "",
      computerName: "",
      computerNumber: "",
      recaptchaVerified:false
    },
    countries: [
      { _id: "A", name: "Österreich" },
      { _id: "D", name: "Deutschland" },
      { _id: "CH", name: "Schweiz" },
      { _id: "FL", name: "Liechtenstein" },
      { _id: "I", name: "Italien" },
      { _id: "B", name: "Belgien" },
      { _id: "F", name: "Frankreich" },
      { _id: "H", name: "Ungarn" }
    ],
    errors: {}
  };

  schema = {
    // _id: Joi.string(),
    companyName: Joi.string()
        .required()
        .label("Firmenname"),
    firstname: Joi.string()
        .required()
        .label("Vorname"),
    surname: Joi.string()
        .required()
        .label("Nachname"),
    email: Joi.string()
        .email()
        .required()
        .label("E-Mail-Adresse"),
    street: Joi.string()
        .required()
        .label("Straße"),
    postalCode: Joi.string()
        .required()
        .label("Postleitzahl"),
    city: Joi.string()
        .required()
        .label("Stadt"),
    countryId: Joi.string()
        .required()
        .label("Land"),
    phone: Joi.string()
        .required()
        .label("Telefon"),
    vendor: Joi.string()
        .required()
        .label("Softwarehändler"),
    computerName: Joi.string()
        .required()
        .label("Computername"),
    computerNumber: Joi.string()
        // 491811223126478 oder 491811223126478-5.1.14-70000001
        .regex(/^[0-9]{8,20}$|^[0-9]{8,20}-[0-9]{1,1}\.[0-9]{1,2}\.[0-9]{1,2}-[0-9]{5,10}$/)
        .required()
        .label("Computernummer"),
    recaptchaVerified:Joi.boolean()
        .invalid(false)
  };

  componentDidMount() {
    // const genres = getGenres();
    // this.setState({ genres });
    //
    // const movieId = this.props.match.params.id;
    // if (movieId === "new") return;
    //
    // const movie = getMovie(movieId);
    // if (!movie) return this.props.history.replace("/not-found");
    //
    // this.setState({ data: this.mapToViewModel(movie) });
  }

  mapToViewModel(foxproRegistration) {
    return {
      // _id: foxproRegistration._id,
      companyName: foxproRegistration.companyName,
      firstname: foxproRegistration.firstname,
      surname: foxproRegistration.surname,
      email: foxproRegistration.email,
      street: foxproRegistration.street,
      postalCode: foxproRegistration.postalCode,
      city: foxproRegistration.city,
      countryId: foxproRegistration.country._id,
      phone: foxproRegistration.phone,
      vendor: foxproRegistration.vendor,
      computerName: foxproRegistration.computerName,
      computerNumber: foxproRegistration.computerNumber,
      recaptchaVerified:foxproRegistration.recaptchaVerified
    };
  }

  doSubmit = async () => {

    const requestResult = await this.transfer();
    console.log("doSubmit(): requestResult=", requestResult)

    if (requestResult === undefined || requestResult.data === undefined) {
        toast.error("Die Registrierung hat nicht funktioniert - bitte probieren Sie es nochmals-1!",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 15000
            }
        );
    } else if (requestResult.data && requestResult.data.error === true) {
      toast.error("Die Registrierung hat nicht funktioniert - bitte probieren Sie es nochmals-2!",
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 15000
          }
      );
    } else {
        this.setState({ data: {
            ...this.state.data,
            computerName: "",
            computerNumber: ""
          } });

        toast.info("Die Daten wurden übertragen. Sie können eine weitere Registrierung erfassen oder die Seite schließen!",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 15000
            }
        );
    }

  };

  transfer = async() => {

    const header = {
      // Authorization: "Bearer " + credentials.access_token,
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json"
    };
    axios.defaults.headers.common = header;

    // console.log("window.location", window.location)
    let url = window.location.origin
    if (url.indexOf("3000") >= 0) {
      url = url.replace("3000", "8080")
      url += ("/registerFoxpro")
    } else {
      url += ("/administration/registerFoxpro")
    }

    const requestResult = await axios.post(url, this.state.data);
    // console.log("transfer(): requestResult=", requestResult)

    return requestResult

  }

  onVerify = recaptchaResponse => {
    this.setState({ data: {
        ...this.state.data,
        recaptchaVerified:true
      }
    })
  }

  onExpire = () => {
    this.setState({ data: {
        ...this.state.data,
        recaptchaVerified:false
      }
    })
  }

  onShowInfosAboutRegistration = (event) => {
    event.preventDefault()
    window.open('https://www.clockwork.at/foxproregistration/registerComputer.pdf', '_blank');
  }

  onShowInfosAboutOLE_Error = (event) => {
    event.preventDefault()
    window.open('https://www.clockwork.at/foxproregistration/ole-errorCode.pdf', '_blank');
  }

  render() {

    const siteKey = (!process.env.NODE_ENV || process.env.NODE_ENV === "development") ? TEST_SITE_KEY : SITE_KEY

    return (
      <div>
        <h1>Computerregistrierung</h1>
        <form onSubmit={this.handleSubmit}>
          {this.renderInput("companyName", "Firmenname")}
          {this.renderInput("firstname",  "Vorname")}
          {this.renderInput("surname",  "Nachname")}
          {this.renderInput("email",  "E-Mail-Adresse")}
          {this.renderInput("street",  "Straße")}
          {this.renderInput("postalCode",  "Postleitzahl")}
          {this.renderInput("city",  "Stadt")}
          {this.renderSelect("countryId", "Land", this.state.countries)}
          {this.renderInput("phone",  "Telefon")}
          {this.renderInput("vendor",  "Softwarehändler")}
          {this.renderInput("computerName",  "Computername")}
          {this.renderInput("computerNumber",  "Computernummer", "zum Beispiel:  491811223126478 oder 491811223126478-5.1.14-70000001")}
          <div className="card">
            <div className="card-body">
              <div>
                <Reaptcha
                    sitekey={siteKey}
                    onVerify={this.onVerify}
                    onExpire={this.onExpire}
                />
              </div>
            </div>
          </div>

          {this.renderSubmitButton("Registrierungsnummer anfordern")}
          <br/>
          <br/>
          <br/>
          {this.renderButton("Informationen zur Registrierung", this.onShowInfosAboutRegistration)}
          {" "}
          {this.renderButton("Informationen zu OLE-Fehlercode", this.onShowInfosAboutOLE_Error)}
        </form>
      </div>
    );
  }
}

export default RegisterFoxproForm;
